// extracted by mini-css-extract-plugin
export default {"appMenuButton":"JmW9JRdPAUWCxbCq18SW","menuButtonLine":"pE8iDdZREiAmGv9u15XC"};